var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cf-node-properties__field-sub-group clearfix" },
    [
      _vm._l(_vm.params, function(param, index) {
        return [
          !param.group
            ? _c(
                "div",
                {
                  key: index,
                  staticClass: "cf-node-properties__field",
                  class: _vm.getFieldSize(param.name)
                },
                [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v("\n        " + _vm._s(param.displayName) + " "),
                    !param.isOptional ? _c("span", [_vm._v("*")]) : _vm._e(),
                    _vm._v(" "),
                    _c("i", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: param.description,
                          expression: "param.description",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass: "fa fa-question-circle m-l-5",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]),
                  _vm._v(" "),
                  param.type === "number"
                    ? _c("InputNumber", {
                        attrs: {
                          placeholder: param.defaultValue,
                          required: !param.isOptional,
                          error: _vm.getFieldError(_vm.errors, param.name)
                        },
                        on: { input: _vm.handleSettingsChange },
                        model: {
                          value: _vm.settings[_vm.parentSetting][param.name],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settings[_vm.parentSetting],
                              param.name,
                              $$v
                            )
                          },
                          expression: "settings[parentSetting][param.name]"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      !_vm.settings.voiceResponse
        ? _c("MultipleToggle", {
            staticClass:
              "cf-node-properties__field-btn-group col-md-6 p-l-0 p-r-0",
            attrs: {
              value: _vm.selectedWhisperType,
              options: _vm.whisperTypeOptions
            },
            on: {
              onToggle: function($event) {
                return _vm.whisperTypeChange($event, "selectedWhisperType")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.settings.voiceResponse
        ? [
            _c("div", { staticClass: "p-t-22" }, [
              _c(
                "label",
                { staticClass: "btn btn-primary active col-md-3 p-l-0 p-r-0" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("AUDIO_COMPONENT_SAY")) +
                      "\n      "
                  )
                ]
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.whisperTypeParameters, function(t, index) {
        return [
          t.name === _vm.selectedWhisperType
            ? _c(
                "div",
                { key: `${t.name}-${index}` },
                _vm._l(
                  t.parameters
                    .filter(p => !p.isHidden)
                    .sort(
                      (a, b) =>
                        _vm.sayInputOrder.indexOf(a.displayName) -
                        _vm.sayInputOrder.indexOf(b.displayName)
                    ),
                  function(p, parameterIndex) {
                    return _c(
                      "div",
                      {
                        key: `param-${index}-${parameterIndex}`,
                        staticClass: "cf-node-properties__field",
                        class: _vm.getFieldSize(
                          p.name,
                          _vm.ivrVoicesFeatureFlag
                        )
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                p.displayName === "Text" &&
                                  _vm.ivrVoicesFeatureFlag
                                  ? _vm.$t("PROMPT_MESSAGE")
                                  : p.displayName
                              ) +
                              " "
                          ),
                          !p.isOptional ? _c("span", [_vm._v("*")]) : _vm._e(),
                          _vm._v(" "),
                          _c("i", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: p.description,
                                expression: "p.description",
                                modifiers: { top: true }
                              }
                            ],
                            staticClass: "fa fa-question-circle m-l-5",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]),
                        _vm._v(" "),
                        p.name === "URL"
                          ? _c(
                              "InputSearchableSelect",
                              {
                                staticClass: "file-upload-input flex--grow",
                                class: {
                                  "is-selected":
                                    _vm.settings[_vm.parentSetting][t.name][
                                      p.name
                                    ]
                                },
                                attrs: {
                                  config: _vm.assetOptions,
                                  required: !p.isOptional,
                                  error: _vm.getFieldError(
                                    _vm.errors,
                                    `${t.name}.${p.name}`
                                  )
                                },
                                on: { input: _vm.handleSettingsChange },
                                model: {
                                  value:
                                    _vm.settings[_vm.parentSetting][t.name][
                                      p.name
                                    ],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings[_vm.parentSetting][t.name],
                                      p.name,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "settings[parentSetting][t.name][p.name]"
                                }
                              },
                              [
                                _c("InputFile", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$t("DIAL_NODE_UPLOAD_AUDIO"),
                                      expression: "$t('DIAL_NODE_UPLOAD_AUDIO')"
                                    }
                                  ],
                                  attrs: {
                                    accept: ".mp3,.wav",
                                    "show-file-name": false
                                  },
                                  on: { change: _vm.uploadAudioFile }
                                }),
                                _vm._v(" "),
                                _vm.settings[_vm.parentSetting][t.name][p.name]
                                  ? _c("RecordingButton", {
                                      staticClass: "p-t-6 p-l-12",
                                      attrs: {
                                        "recording-url":
                                          _vm.settings[_vm.parentSetting][
                                            t.name
                                          ][p.name],
                                        "no-float": ""
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : p.name === "language"
                          ? _c("InputSelect", {
                              attrs: {
                                options:
                                  _vm.ivrVoicesFeatureFlag &&
                                  _vm.settings.voiceResponse
                                    ? _vm.newLanguageOptions
                                    : _vm.legacyLanguageOptions,
                                required: !p.isOptional,
                                error: _vm.getFieldError(
                                  _vm.errors,
                                  `${t.name}.${p.name}`
                                )
                              },
                              on: { input: _vm.handleLanguageChange },
                              model: {
                                value:
                                  _vm.settings[_vm.parentSetting][t.name][
                                    p.name
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.settings[_vm.parentSetting][t.name],
                                    p.name,
                                    $$v
                                  )
                                },
                                expression:
                                  "settings[parentSetting][t.name][p.name]"
                              }
                            })
                          : p.name === "text"
                          ? _c(
                              "InputTextarea",
                              {
                                attrs: {
                                  required: !p.isOptional,
                                  error: _vm.getFieldError(
                                    _vm.errors,
                                    `${t.name}.${p.name}`
                                  )
                                },
                                on: { input: _vm.handleVoiceTextChange },
                                model: {
                                  value:
                                    _vm.settings[_vm.parentSetting][t.name][
                                      p.name
                                    ],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings[_vm.parentSetting][t.name],
                                      p.name,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "settings[parentSetting][t.name][p.name]"
                                }
                              },
                              [
                                _c("RecordingButton", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.ivrVoicesFeatureFlag &&
                                        !_vm.isLegacyVoiceSelected,
                                      expression:
                                        "ivrVoicesFeatureFlag && !isLegacyVoiceSelected"
                                    }
                                  ],
                                  ref: "recordingButton",
                                  refInFor: true,
                                  staticClass: "p-t-6",
                                  attrs: {
                                    "recording-url":
                                      _vm.newTextToSpeechRecordingUrl,
                                    "icon-button": false,
                                    "no-float": "",
                                    disabled:
                                      !_vm.settings[_vm.parentSetting][t.name][
                                        p.name
                                      ] ||
                                      _vm.recordingIsLoading ||
                                      !_vm.newTextToSpeechRecordingUrl
                                  }
                                })
                              ],
                              1
                            )
                          : p.name === "voice" && !_vm.ivrVoicesFeatureFlag
                          ? _c("InputSelect", {
                              attrs: {
                                options:
                                  _vm.ivrVoicesFeatureFlag &&
                                  _vm.availableVoicesList
                                    ? _vm.availableVoicesList
                                    : p.values,
                                required: !p.isOptional,
                                error: _vm.getFieldError(
                                  _vm.errors,
                                  `${t.name}.${p.name}`
                                )
                              },
                              on: { input: _vm.handleVoiceChange },
                              model: {
                                value:
                                  _vm.settings[_vm.parentSetting][t.name][
                                    p.name
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.settings[_vm.parentSetting][t.name],
                                    p.name,
                                    $$v
                                  )
                                },
                                expression:
                                  "settings[parentSetting][t.name][p.name]"
                              }
                            })
                          : p.name === "voice" && _vm.ivrVoicesFeatureFlag
                          ? _c("InputVoiceSelector", {
                              attrs: {
                                voices: _vm.filterVoices(),
                                required: !p.isOptional,
                                error: _vm.getFieldError(
                                  _vm.errors,
                                  `${t.name}.${p.name}`
                                )
                              },
                              on: { input: _vm.handleVoiceChange },
                              model: {
                                value:
                                  _vm.settings[_vm.parentSetting][t.name][
                                    p.name
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.settings[_vm.parentSetting][t.name],
                                    p.name,
                                    $$v
                                  )
                                },
                                expression:
                                  "settings[parentSetting][t.name][p.name]"
                              }
                            })
                          : p.type === "number"
                          ? _c("InputNumber", {
                              attrs: {
                                required: !p.isOptional,
                                error: _vm.getFieldError(
                                  _vm.errors,
                                  `${t.name}.${p.name}`
                                )
                              },
                              on: { input: _vm.handleSettingsChange },
                              model: {
                                value:
                                  _vm.settings[_vm.parentSetting][t.name][
                                    p.name
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.settings[_vm.parentSetting][t.name],
                                    p.name,
                                    $$v
                                  )
                                },
                                expression:
                                  "settings[parentSetting][t.name][p.name]"
                              }
                            })
                          : p.type === "string"
                          ? _c("InputText", {
                              attrs: {
                                required: !p.isOptional,
                                error: _vm.getFieldError(
                                  _vm.errors,
                                  `${t.name}.${p.name}`
                                )
                              },
                              on: { input: _vm.handleSettingsChange },
                              model: {
                                value:
                                  _vm.settings[_vm.parentSetting][t.name][
                                    p.name
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.settings[_vm.parentSetting][t.name],
                                    p.name,
                                    $$v
                                  )
                                },
                                expression:
                                  "settings[parentSetting][t.name][p.name]"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }
                ),
                0
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }